import React from 'react';
const CalendarLines = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='227' height='8' viewBox='11 1.5 227 5' preserveAspectRatio="none">
      <path fill='none' stroke='var(--theme-light,#e2cff6)' strokeDasharray='2 30' strokeWidth='8px' d='M227 0H0' transform='translate(0 4)' />
    </svg>
  );
};

export default CalendarLines;
